import toast from "react-hot-toast";
import useRead from "../../useRead";
import { useState } from "react";
import { useForm } from "react-hook-form";
import usePut from "../../usePut";

const useManageStatutoryComponents = () => {
  const { register, handleSubmit, setValue } = useForm({
    defaultValues: {
      statutory: {},
    },
  });

  const [statutoryComponentsList, setStatutoryComponentsList] = useState([]);

  // Fetch Statutory Components
  const { list: fetchStatutoryRequest } = useRead({
    url: "statutory-types/list",
    method: "GET",
    initialData: {},
    onSuccess: (data) => {
      const resData = data?.data || [];

      const statutoryData = {};
      (resData || []).forEach((cmp) => {
        statutoryData[cmp.name] = cmp.mapped_to_company || false;
      });
      setValue("statutory", statutoryData);

      setStatutoryComponentsList(resData);
    },
    onError: (error) => {
      toast.error(
        error?.response?.data?.message ||
          "Error fetching statutory components: " + error.message
      );
    },
  });
  const isFetchingStatutory = fetchStatutoryRequest.isLoading;

  const { handleAuth: updateRequest } = usePut({
    url: "company-statutory-details/manageCompanyStatutoryMap",
    onSuccess: (data) => {
      toast.success("Statutory components updated successfully");
    },
    onError: (error) => {
      toast.error(
        error?.response?.data?.message ||
          "Error updating statutory components: " + error.message
      );
    },
  });

  const updateStatutoryComponents = (data) => {
    const statutoryArr = Object.keys(data.statutory);

    const finalStatutoryArr = statutoryArr.map((key) => {
      const statutoryComponent = statutoryComponentsList.find(
        (sc) => sc.name === key
      );

      return {
        ...statutoryComponent,
        mapped_to_company: data.statutory[key] || false,
      };
    });

    const finalStatutoryData = finalStatutoryArr.filter(
      (item) => item.mapped_to_company === true
    );

    updateRequest.mutate({ statutory_data: finalStatutoryData });
  };

  return {
    statutoryComponentsList,
    isFetchingStatutory,
    register,
    handleSubmit,
    updateStatutoryComponents,
  };
};

export default useManageStatutoryComponents;
